import { db } from '@app/icare/client/db'
import { localCountQueryOptions, localResultQueryOptions } from '@app/icare/client/db/client/localQueryOptions'
import { jsonObjectFrom } from '@app/icare/db/query/jsonHelpers'
import { CostCarrierSchema } from '@app/icare/entities/costCarrier/schema/CostCarrier'
import type { PatientIdType } from '@app/icare/entities/patient/schema/PatientId'
import { zodObjectRootKeys } from '@pkg/api/query'
import dayjs from 'dayjs'

export const patientCostCarrierQueries = {
  /** Active relations only, with the joined `to: CostCarrier` object. Used by the tab bar. */
  forTabs: (patientId: PatientIdType) =>
    localResultQueryOptions({
      meta: { scope: { patientId: String(patientId), tags: ['patientCostCarrier'] } },
      query: db
        .selectFrom('patientCostCarrier')
        .selectAll()
        .where('patientId', '=', patientId)
        .where('deletedAt', 'is', null)
        .select(eb =>
          jsonObjectFrom(
            eb
              .selectFrom('costCarrier')
              .select(zodObjectRootKeys(CostCarrierSchema, 'costCarrier.'))
              .whereRef('costCarrier.id', '=', 'patientCostCarrier.toId'),
          ).as('to'),
        )
        .where(eb => eb.or([eb('activeTo', 'is', null), eb('activeTo', '>=', dayjs().format('YYYY-MM-DD'))]))
        .orderBy('activeFrom', 'asc'),
    }),

  /** Total count of active + inactive relations — used by the tab bar. */
  totalCount: (patientId: PatientIdType) =>
    localCountQueryOptions({
      meta: { scope: { patientId: String(patientId), tags: ['patientCostCarrier'] } },
      query: db.selectFrom('patientCostCarrier').where('patientId', '=', patientId).where('deletedAt', 'is', null),
    }),

  /** Bare columns, no join, no active filter. Used by the historical index table. */
  forIndex: (patientId: PatientIdType) =>
    localResultQueryOptions({
      meta: { scope: { patientId: String(patientId), tags: ['patientCostCarrier'] } },
      query: db
        .selectFrom('patientCostCarrier')
        .select(['id', 'toId', 'activeFrom', 'activeTo', 'deletedAt'])
        .where('patientId', '=', patientId)
        .where('deletedAt', 'is', null),
    }),
}
